import { useState } from "react";
import ModuleTextInput from "./components/ModuleTextInput";
import { triggerSaveFeatureData, undoRedoHook } from "../../v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions";

const PresetsModule = (props) => {
    console.log("PresetsModule props:", props);

    const options = [];
    let pIndex = 0;
    for (const preset of props.presets) {
        options.push({
            label: preset.name,
            value: pIndex
        });
        pIndex++;
    }

    const [currentValue, setCurrentValue] = useState(null);
    const changeFieldValue = (fieldId, value) => {
        console.log("PresetsModule: Changing field value:", fieldId, value);
        setCurrentValue(value);
    }

    const applyPresetNow = (selectedPresetIndex) => {
        console.log("Applying preset index:", selectedPresetIndex);
        if (selectedPresetIndex === null || typeof selectedPresetIndex === 'undefined' || selectedPresetIndex < 0 || selectedPresetIndex >= props.presets.length) {
            console.warn("PresetsModule: Invalid preset index selected:", selectedPresetIndex);
            return;
        }
        const preset = props.presets[selectedPresetIndex];
        if (!preset || !preset.vals) {
            console.warn("PresetsModule: No preset data found for index:", selectedPresetIndex);
            return;
        }
        const vals = props.vals;
        console.log("Current vals before applying preset:", vals);

        // first clear out the current vals array, but store it in case any vals in our preset are missing!
        const baseVals = props.defaultVals;
        const prevVals = [];
        while (vals.length > 0) {
            // oldVals.push(vals.shift());
            prevVals.push(vals.pop());
        }

        // now insert new preset vals
        let presetsArray = preset.vals;
        for (let i = 0; i < presetsArray.length; i++) {
            console.log("Applying preset val for index:", i, presetsArray[i]);
            vals.push({...presetsArray[i]});
            // If a val doesn't exist in our preset keep the old value.
            // We do this so we can have partial presets where not every value is replaced...
            let valFixed = false;
            if (baseVals.length > i) {
                for (let prop in baseVals[i]) {
                    if (typeof vals[i][prop] === 'undefined') {
                        vals[i][prop] = baseVals[i][prop];
                        valFixed = true;
                    }
                }
            }
            // No val set? Let's try the default vals.
            /* if (!valFixed) {
                if (presetsData_ref.current.vals.length > i) {
                    const defaultVals = presetsData_ref.current.vals;
                    for (let prop in defaultVals[i]) {
                        if (typeof vals[i][prop] === 'undefined') {
                            vals[i][prop] = defaultVals[i][prop];
                            valFixed = true;
                        }
                    }
                }
            } */
            // Or from our valSchema default settings..
            /* if (!valFixed) {
                const valSchema = presetsData_ref.current.valSchema;
                for (let prop in valSchema) {
                    if (typeof vals[i][prop] === 'undefined' && typeof valSchema[prop].default !== 'undefined' && valSchema[prop.default !== null]) {
                        vals[i][prop] = valSchema[prop].default;
                        valFixed = true;
                    }
                }
            } */
        }

        // console.log("Preset applied, fixing src urls.", vals, baseVals, props);

        // featureData, featureId, campaignId, customisationDataIn = null, dataToFix = null
        props.fixSrcUrlsFunc(props.featureData, props.featureData._id, props.campaignData._id, null, props.selectedFeatureNode?.customisationVars ?? props.activeNode?.customisationVars);
        props.forceUpdateComponent();
        props.updateModulesListFunc();
        undoRedoHook?.recordCustomisationArrayValuesReplaced?.(props.selectedFeatureNode ?? props.activeNode, vals, prevVals, [...vals]);
        triggerSaveFeatureData(props.featureData._id);

        /* let presetsArray = presetsData_ref.current.vals;
        if (presetIndex >= 0) {
            presetsArray = presetsData_ref.current.presets[presetIndex].vals;
        }

        // first clear out the current vals array, but store it in case any vals in our preset are missing!
        const oldVals = [];
        while (presetVarsParent.current.length > 0) {
            oldVals.push(presetVarsParent.current.shift());
        }
        // now insert new preset vals
        for (let i = 0; i < presetsArray.length; i++) {
            presetVarsParent.current.push({...presetsArray[i]});
            // If a val doesn't exist in our preset keep the old value.
            // We do this so we can have partial presets where not every value is replaced...
            let valFixed = false;
            if (oldVals.length > i) {
                for (let prop in oldVals[i]) {
                    if (typeof presetVarsParent.current[i][prop] === 'undefined') {
                        presetVarsParent.current[i][prop] = oldVals[i][prop];
                        valFixed = true;
                    }
                }
            }
            // No val set? Let's try the default vals.
            if (!valFixed) {
                if (presetsData_ref.current.vals.length > i) {
                    const defaultVals = presetsData_ref.current.vals;
                    for (let prop in defaultVals[i]) {
                        if (typeof presetVarsParent.current[i][prop] === 'undefined') {
                            presetVarsParent.current[i][prop] = defaultVals[i][prop];
                            valFixed = true;
                        }
                    }
                }
            }
            // Or from our valSchema default settings..
            if (!valFixed) {
                const valSchema = presetsData_ref.current.valSchema;
                for (let prop in valSchema) {
                    if (typeof presetVarsParent.current[i][prop] === 'undefined' && typeof valSchema[prop].default !== 'undefined' && valSchema[prop.default !== null]) {
                        presetVarsParent.current[i][prop] = valSchema[prop].default;
                        valFixed = true;
                    }
                }
            }
        }

        fixSrcUrls(featureData);

        if (presetUpdatedCallback.current) {
            presetUpdatedCallback.current();
        } */
    }

    return (
        <div className="v2-basic-module-holder presets-module">
            <h5>Apply Preset</h5>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column v2-full-width'>
                    <ModuleTextInput
                        value={currentValue === null ? 'Choose Preset' : options[currentValue]?.label || 'Choose Preset'}
                        fieldId={'preset-drop-down'}
                        enabled={true}
                        editable={false}
                        onChange={changeFieldValue}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={options}
                        dropDownValue={currentValue}
                    />
                </div>
            </div>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'></div>
                <div className='v2-module-one-column'>
                    <button
                        className={`v2-module-button${currentValue === null ? ' disabled' : ''}`}
                        onClick={
                            currentValue === null ? null :
                            (e) => {
                                console.log('Apply Preset clicked', currentValue);
                                applyPresetNow(currentValue);
                            }
                        }
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PresetsModule;
